export const like_action = "like_action/change";


export const likeChange = (id, selected, callback=null) => ({
    type: like_action,
    payload: {
        id,
        selected,
        callback
    }
});


// WEBPACK FOOTER //
// ./src/libs/redux/actions/like.js